import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e923cf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["id", "name", "type", "value", "placeholder", "step"]
const _hoisted_5 = { class: "help-message absolute p-1 text-sm" }

import {
  EyeIcon, EyeOffIcon,
} from '@heroicons/vue/outline';
import {
  useField,
} from 'vee-validate';
import {
  PropType,
  computed,
  onMounted,
  ref,
  toRef,
  watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputHelper',
  props: {
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  step: {
    type: [Number, String],
    default: 1,
  },
  required: {
    type: Boolean,
    default: false,
  },
  focused: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String as PropType<'text' | 'password' | 'number' | 'email' | 'url'>,
    default: 'text',
    validator: (type: string) => type === 'text'
      || type === 'password' || type === 'number'
      || type === 'email' || type === 'url',
  },
  value: {
    type: String,
    default: '',
  },
  successMessage: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  errorText: {
    type: String,
    default: '',
  },
},
  emits: ["input", "blur", "change"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'input', value: string): void;
  (e: 'blur', value: string): void;
  (e: 'change', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



// TODO: add focused props to focus first input in form


const isPasswordHidden = ref(true);
const isPasswordType = computed(() => props.type === 'password');

const computedType = computed(() => {
  if (isPasswordType.value && !isPasswordHidden.value) {
    return 'text';
  }
  return props.type;
});

const name = toRef(props, 'name');

// we don't provide any rules here because we are using form-level validation
// https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
const {
  value: inputValue,
  resetField,
  setState,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(name, undefined, {
  initialValue: props.value,
});

watch(() => props.value, () => {
  resetField({
    value: props.value,
  });
});

const inputEl = ref<HTMLInputElement | null>(null);

onMounted(() => {
  if (props.focused && inputEl.value) {
    inputEl.value.focus();
  }
});

function onInput(e): void {
  handleChange(e);
  emits('input', inputValue.value);
}

function onBlur(e): void {
  setState({
    value: e.target.value.trim(),
  });

  emits('blur', inputValue.value);
  handleBlur(e);
}

function onChange(): void {
  emits('change', inputValue.value);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative pb-6", {
      'has-error': !!_unref(errorMessage) || __props.errorText,
      success: _unref(meta).valid && !__props.errorText
    }])
  }, [
    _createElementVNode("label", {
      class: "label block pt-0",
      for: _unref(name)
    }, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      (__props.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: _unref(name),
        ref_key: "inputEl",
        ref: inputEl,
        name: _unref(name),
        type: _unref(computedType),
        value: _unref(inputValue),
        placeholder: __props.placeholder,
        class: _normalizeClass(_unref(isPasswordType) ? 'pr-10' : 'pr-3'),
        step: props.step,
        onInput: onInput,
        onBlur: onBlur,
        onChange: onChange
      }, null, 42, _hoisted_4),
      (_unref(isPasswordType))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isPasswordHidden.value)
              ? (_openBlock(), _createBlock(_unref(EyeOffIcon), {
                  key: 0,
                  class: "mt-4 -ml-8 h-6 w-6 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isPasswordHidden.value = !isPasswordHidden.value), ["prevent"]))
                }))
              : (_openBlock(), _createBlock(_unref(EyeIcon), {
                  key: 1,
                  class: "mt-4 -ml-8 h-6 w-6 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isPasswordHidden.value = !isPasswordHidden.value), ["prevent"]))
                }))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_5, [
      (_unref(errorMessage) || __props.errorText)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_unref(errorMessage) || __props.errorText), 1)
          ], 64))
        : (_unref(meta).valid)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(__props.successMessage), 1)
            ], 64))
          : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})